import $ from 'jquery'

var scrollTo = function () {

  $('.sidebar__nav ul li a').click(function (e) {
    e.preventDefault();

    var anchor = $(this).attr('data-anchor');
    var divAnchor = $('#' + anchor);
    var offset = $(divAnchor).offset().top;


    var sideNav = document.querySelector('.sidebar__nav');
    var listOffset = offset - 42 - sideNav.offsetTop;

    console.log(listOffset);

    $('body, html').animate({
      scrollTop: listOffset
    }, '400');

    $(this).addClass('active').parent().siblings().find('a').removeClass('active');
  });

  var currentPos = $('.sidebar__nav ul li.active');
}



module.exports = scrollTo;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/scroll-to.js